

exports.__esModule = true;
exports.$ReturnToMerchant = undefined;
exports.goTo = goTo;
exports.postToMerchant = postToMerchant;
exports.postTo = postTo;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _index = require('xo-device-info/dist/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _index2 = require('xo-models/src/checkout/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function goTo(url, forceRedirect) {

    _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
        url: url
    });

    // if V4 in-context integration, we'll terminate and call the close handler.
    if (window.xchild) {
        _logger.$logger.done();
        _angular.$rootScope.$emit('loading');

        var paymentToken = _angular.$rootScope.token;
        var cart = _index2.$CheckoutCartModel.instance(paymentToken);
        var appData = _index2.$CheckoutAppDataModel.instance(paymentToken);
        var orderID = paymentToken;
        var intent = cart.payment_action;
        var billingToken = cart.billing && cart.billing.ba_token;
        var paymentID = appData.payment_id;
        var cancelUrl = url;

        return window.xprops.onCancel({
            paymentToken: paymentToken,
            billingToken: billingToken,
            orderID: orderID,
            paymentID: paymentID,
            intent: intent,
            cancelUrl: cancelUrl
        });
    }

    var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
    var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl);

    if (showPaymentSuccess) {
        _logger.$logger.info('redirect', {
            url: url
        });
        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
        };
        _angular.$window.location = url;
        return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS'
        });
    }

    if (forceRedirect) {
        _squid.$util.redirect(url);
    } else {
        var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();

        if (isVZeroIframe) {
            _squid.$util.redirect(url, { redirectImmediateParent: true });
        }

        // If we are not in minibrowser, do a hard redirect
        else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
                _squid.$util.redirect(url);
            } else {

                // Construct a message to send to the parent
                var result = this.postToMerchant({
                    operation: 'return_to_merchant',
                    returnUrl: url,
                    updateParent: true
                });

                // Otherwise we have no choice but to return to the merchant
                if (!result) {
                    _squid.$util.redirect(url);
                }
            }
    }

    var userStatus = function userStatus() {
        _logger.$logger.info('redirected_user_still_on_page_second_checkpoint');
    };

    (0, _angular.$timeout)(function () {
        _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
        (0, _angular.$timeout)(userStatus, 10000);
    }, 10000);
}

function postToMerchant(msg) {

    try {
        msg = _angular2['default'].toJson(msg, 0);

        // If we are not in IE, attempt to send a postMessage
        if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
            _angular.$window.opener.postMessage(msg, '*');
            _logger.$logger.info('minibrowser_postmessage');
            return true;
        }
        // Otherwise, attempt to send a message through the iframe bridge
        var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;

        if (bridge && bridge.returnToParent) {
            bridge.returnToParent(msg);
            _logger.$logger.info('minibrowser_bridgemessage');
            return true;
        }

        _logger.$logger.warn('minibrowser_nopostback');
    } catch (err) {
        _logger.$logger.error('minibrowser_postback_error', {
            error: err.stack || err.toString()
        });
    }

    return false;
}

function postTo(url, msg) {
    var form = document.createElement('form');

    form.method = 'POST';
    form.action = url;
    form.className = 'hide';

    for (var key in msg) {
        var input = document.createElement('input');

        input.name = key;
        input.value = msg[key];
        form.appendChild(input);
    }

    _angular.$window.document.body.appendChild(form);
    form.submit();
    _logger.$logger.info('web_postmessage');
    return true;
}

var $ReturnToMerchant = exports.$ReturnToMerchant = {
    goTo: goTo,
    postToMerchant: postToMerchant,
    postTo: postTo
};

_angular2['default'].value("goTo", goTo);
_angular2['default'].value("postToMerchant", postToMerchant);
_angular2['default'].value("postTo", postTo);
_angular2['default'].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;

_logger.$logger;

_uiRouter.$state;

_squid.$util;

_index2.$CheckoutCartModel;

_index2.$CheckoutAppDataModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-return-to-merchant/dist/util.js
// module id = ./components/xo-return-to-merchant/dist/util.js
// module chunks = 1